interface StarClausesIconProps {
  isActive?: boolean;
}

const StarClausesIcon: React.FC<StarClausesIconProps> = ({ isActive }) => {
  return (
    // <svg
    //   width="32"
    //   height="32"
    //   viewBox="0 0 34 32"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M16.9999 22.6499L10.7333 26.4333L12.3833 19.2999L6.84992 14.4999L14.1499 13.8833L16.9999 7.14992L19.8499 13.8833L27.1499 14.4999L21.6166 19.2999L23.2666 26.4333L16.9999 22.6499ZM33.6666 12.3999L21.6833 11.3833L16.9999 0.333252L12.3166 11.3833L0.333252 12.3999L9.41658 20.2833L6.69992 31.9999L16.9999 25.7833L27.2999 31.9999L24.5666 20.2833L33.6666 12.3999Z"
    //     fill={isActive ? "#663399" : "#A5A5A5"}
    //   />
    // </svg>
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0125 8.7875L25 9.55L18.175 15.4625L20.225 24.25L12.5 19.5875L4.775 24.25L6.8125 15.4625L0 9.55L8.9875 8.7875L12.5 0.5L16.0125 8.7875Z"
        fill={isActive ? "#9945EE" : "#A5A5A5"}
      />
    </svg>
  );
};

export default StarClausesIcon;
